import { MaybeRef, MaybeRefOrGetter, toValue, computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { STALE_TIME, whenAuthenticatedAnd } from '@/utils/query-utils'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { MeasurementType } from '@/configuration/measurements/measurement-types'

export const useGeneratorMeasurementsQuery = (
    generatorId: MaybeRefOrGetter<string>, measurementType: MaybeRef<MeasurementType>, disabled: MaybeRef<boolean> = false
) => {
    return useQuery({
        queryKey: ['generators', generatorId, 'measurements', measurementType],
        queryFn: async ({ signal }) => {
            const { data: { result } } = await hcaClientFactory.componentStatusApi.listGeneratorAnalysisByType(toValue(generatorId), toValue(measurementType), undefined, undefined, undefined, undefined, undefined, { signal })

            return result
        },
        enabled: whenAuthenticatedAnd(computed(() => !toValue(disabled))),
        staleTime: STALE_TIME,
    })
}
